import React from 'react'
import { SellableSpecificationFragment } from '#src/generated/graphql'
import capitalize from 'lodash/capitalize'
import styles from './styles.css'

interface SpecificationsProps {
  specifications: SellableSpecificationFragment[]
}

interface SpecificationTableProps {
  specifications: SellableSpecificationFragment[]
}

const SpecificationsTable: React.SFC<SpecificationTableProps> = ({ specifications }) => {
  return (
    <div className={styles.specifications}>
      {specifications.map((spec, idx) => (
        <div className={styles.specificationRow} key={idx}>
          <div className={styles.specificationName}>{capitalize(spec.name)}</div>
          <div
            className={styles.specificationValue}
            dangerouslySetInnerHTML={{ __html: spec.valueHtml! }}
          />
        </div>
      ))}
    </div>
  )
}

const Specifications: React.SFC<SpecificationsProps> = ({ specifications }) => {
  // This field could be missing despite the GQL typings
  if (!specifications || !specifications.length) {
    return null
  }

  const ignoredSpecifications = ['attribute:charterAmenities', 'attribute:charterLocation']
  const filteredSpecifications = specifications.filter(spec => {
    if (spec.key && !ignoredSpecifications.includes(spec.key)) {
      return spec
    }
  })

  return filteredSpecifications.length > 0 ? (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <SpecificationsTable specifications={filteredSpecifications} />
      </div>
    </div>
  ) : null
}

export default Specifications
